/**
 * Created by Alex Xia on 10/25/2018.
 * Description:
 * Add contact body component
 *
 * ------ maintenance history ------
 */
import { Component, OnInit, Input } from '@angular/core';
import 'rxjs/add/operator/switchMap';

import { Contact } from '../../tamalelibs/models/contact.model';
import { ContactDetailConfig } from './contact-detail.config';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'contact-body',
    templateUrl: './contact-body.component.html',
    styleUrls: ['./contact-body.component.scss']
})
export class ContactBodyComponent implements OnInit {
    @Input() config: ContactDetailConfig;

    contact: Contact = new Contact();
    defaultRelationshipTypeName: string;
    socialMediaObj: Object = new Object();
    facebook: string;
    linkedIn: string;
    skype: string;
    twitter: string;
    other: string;
    imValue: string;
    isOtherLink: boolean;

    constructor() {
    }

    ngOnInit() {
        this._init();
        this.config.actions$.subscribe(action => this._onSubscribeActions(action));
    }

    // handle link in social media
    formatExternal(link) {
        const reg = new RegExp('^http');
        if (!reg.test(link)) {
            link = 'http://' + link;
        }
        return link;
    }

    private _init() {
        if (this.config && this.config.contact) {
            this.contact = this.config.contact;

            this._initIMValue(this.contact);
            this._initSocialMedia(this.contact);
            this._initRelationshipType(this.contact);
        }
    }

    private _initIMValue(contact: Contact) {
        if (contact && contact.imHandle) {
            this.imValue = contact.imHandle + '(' + contact.imService + ')';
        }
    }

    private _initRelationshipType(contact: Contact) {
        if (contact && contact.defaultRelationshipType) {
            if (contact.defaultRelationshipType['link']) {
                this.defaultRelationshipTypeName = contact.defaultRelationshipType['link'].phid;
            } else {
                this.defaultRelationshipTypeName = contact.defaultRelationshipType.name;
            }
        }
    }

    private _initSocialMedia(contact: Contact) {
        if (contact && contact.socialMedia) {
            // this.facebook = this.contact.socialMedia.get('facebook');
            // this.linkedIn = this.contact.socialMedia.get('linkedIn');
            // this.skype = this.contact.socialMedia.get('skype');
            // this.twitter = this.contact.socialMedia.get('twitter');

            // this.other = this.contact.socialMedia.get('other');
            this._verifyOtherValue(this.other);
        }
    }

    private _onSubscribeActions(action: any) {
        this._init();
    }

    // special handle the 'other' item in social media
    private _verifyOtherValue(other: string) {
        this.isOtherLink = false;
        if (other) {
            const reg = new RegExp('^http');
            if (reg.test(other)) {
                this.isOtherLink = true;
            }
        }
        return this.isOtherLink;
    }
}
